// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-rounded[data-v-6abdc38c]{border:1px solid #dcdcdc;overflow:hidden;border-radius:12px}", ""]);
// Exports
module.exports = exports;
